module.exports = __webpack_public_path__ + "static/media/3.41ff7e15.jpg";